import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('mono_token');
    if (token) {
      // Dummy check bypass
      setUser({ id: 'dummy_user_1', name: 'Demo User', email: 'demo@brand.com', plan: 'pro' });
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    // Dummy bypass
    const fakeData = { token: 'dummy_token_123', user: { id: 'dummy_user_1', name: 'Demo User', email, plan: 'pro' } };
    localStorage.setItem('mono_token', fakeData.token);
    setUser(fakeData.user);
    return fakeData;
  };

  const register = async (name, email, password) => {
    // Dummy bypass
    const fakeData = { token: 'dummy_token_123', user: { id: 'dummy_user_1', name, email, plan: 'pro' } };
    localStorage.setItem('mono_token', fakeData.token);
    setUser(fakeData.user);
    return fakeData;
  };

  const logout = () => {
    localStorage.removeItem('mono_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
